module.exports = __webpack_public_path__ + "img/baby2.ec987c7b.png";